import { CircularProgress } from "@mui/material";


function Card({ label, number, className }) {
   return <div className={`inline-flex flex-col gap-1 text-center ${className} text-gray-600`}>
      <div className="text-sm font-extrabold">
         {number.toString().padStart(2, '0')}
      </div>
      <div className="text-[10px] uppercase">
         {label}
      </div>
   </div>
}

export default function Statistic(props) {

   const { principal, owing, unpaid_interest } = props; 
   const unpaid_principal = owing - unpaid_interest;

   const paidPercentage = (principal - unpaid_principal) / principal * 100;

   const numberOfScheduledPayments = props.payments
      .filter(p => !p.overdue)
      .filter(p => !p.paid)
      .length;

   const numberOfMissedPayments = props.payments
      .filter(p => p.overdue)
      .filter(p => !p.paid)
      .length;

   const numberOfPaidPayments = props.payments
      .filter(p => p.paid)
      .length;
   

   let numberOfRecentOverduePayments = 0;

   for (const payment of props.payments) {
      if (!payment.overdue) {
         numberOfRecentOverduePayments = 0; // reset the counter
         continue;
      }

      if (payment.paid) {
         numberOfRecentOverduePayments = 0; // reset the counter
         continue;
      }

      numberOfRecentOverduePayments++; // increment the counter for recent overdue payments
   }

   const circularProgressSize = 100;
   const circularProgressThickness = 6;

   return <div className="flex items-center justify-center gap-2 px-8 pt-8 border rounded-lg border-gray-300">
      <div className="w-full">
         <div className="flex flex-col items-center">
            <div className="relative">
               <CircularProgress
                  size={circularProgressSize}
                  thickness={circularProgressThickness}
                  variant="determinate"
                  value={100}
                  className="absolute top-0 left-0 [&_.MuiCircularProgress-circle]:text-gray-200"
               />
               <CircularProgress
                  size={circularProgressSize}
                  thickness={circularProgressThickness}
                  variant="determinate"
                  value={paidPercentage}
               />
               <div className="absolute top-0 bottom-0 left-0 right-0 text-gray-500 flex items-center justify-center">
                  <b>{paidPercentage.toFixed(0)}</b>%
               </div>
            </div>
            <div className="text-xs text-gray-400 mt-2">
               Repaid
            </div>
         </div>
         <div className="w-full flex justify-evenly mt-8 border-t py-4">
            <Card label="Paid" number={numberOfPaidPayments} className="text-green-600" />
            <Card label="Missed" number={numberOfMissedPayments} className="text-yellow-600" />
            <Card label="Overdue" number={numberOfRecentOverduePayments} className="text-red-600" />
            <Card label="Scheduled" number={numberOfScheduledPayments} />
         </div>
      </div>
   </div>
}